import {
  Component,
  ViewEncapsulation
} from '@angular/core';

@Component({
  selector: 'td-wb-selectable-input-panel',
  template: '<ng-content />',
  styleUrls: ['selectable-input-panel.component.scss'],
  encapsulation: ViewEncapsulation.None,
  host: {
    '[class.td-wb-selectable-input-panel]': 'panelClass'
  }
})
export class SelectableInputPanelComponent {
  readonly panelClass: boolean = true;
}
